import {Box} from '@buncha/components/core/view';
import {CustomImage} from '@buncha/components/core/Image';
import {ItemDetailsScreen} from '@buncha/itemDetails/navigation/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {navigation} from '@buncha/config/navigation';

import {CustomText, H6Text} from '@buncha/components/core/text';
import React, {useCallback} from 'react';
import {
  RecommendedItemCell,
  ReplacementItemDetails,
} from '@buncha/itemDetails/types/itemReplacement';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

interface ItemCellProps {
  itemInfo?: RecommendedItemCell;
  orderItem?: ReplacementItemDetails;
  runId?: number;
  quantity?: number;
}

const SimilarItemCell = (props: ItemCellProps) => {
  const item = props?.itemInfo;
  const name = item?.name || '';
  const imageUrl = item?.itemImageUrl || '';
  const price = (item?.price || 0) / 100;
  const catalogItemId = item?.id || 0;
  const theme = useColorThemeType();
  const muli = useFontTheme('muli');

  const onClick = useCallback(() => {
    navigation.replace(ShopperScreens.ItemDetails, {
      screen: ItemDetailsScreen.ReplacementItemDetailsPage,
      params: {
        catalogItemId: catalogItemId,
        storeIndex: props?.orderItem?.order?.run?.store?.elasticSearchIndex,
        runId: props?.runId,
        quantity: props?.quantity,
        catalogItem: item,
        orderItem: props?.orderItem,
        storeId: props?.orderItem?.order?.run?.store?.id,
      },
    });
  }, [catalogItemId, item, props?.orderItem, props?.quantity, props?.runId]);

  return (
    <React.Fragment>
      <Touchable onPress={onClick}>
        <Box style={[styles.parentBox, {borderColor: theme?.text?.gray[300]}]}>
          <Box style={styles.imageBox}>
            <CustomImage style={styles.image} source={imageUrl} />
          </Box>
          <Box style={styles.textBox}>
            <Box style={styles.namePriceBox}>
              <CustomText
                numberOfLines={3}
                alignText="left"
                style={{
                  color: theme?.text?.blue?.[300],
                  fontFamily: muli?.[700]?.normal,
                }}>
                {name}
              </CustomText>
              <H6Text
                alignText="left"
                style={{
                  color: theme?.text?.blue?.[300],
                  fontFamily: muli?.[700]?.normal,
                }}>
                $ {price}
              </H6Text>
            </Box>
          </Box>
        </Box>
      </Touchable>
    </React.Fragment>
  );
};

export default React.memo(SimilarItemCell);

const styles = StyleSheet.create({
  parentBox: {
    width: 120,
    minHeight: 180,
    borderRadius: 9,
    borderWidth: 1,
    marginBottom: 60,
    padding: 5,
    marginRight: 5,
  },
  imageBox: {
    alignItems: 'center',
    position: 'relative',
    marginBottom: 5,
  },
  image: {
    height: 85,
    width: 85,
  },
  textBox: {flex: 1},
  namePriceBox: {gap: 5},
});
